import {Component, OnInit, ViewChild} from '@angular/core';
import {Model} from '../../../Models/Model';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormGroup} from '@angular/forms';
import {ModelService} from '../../../Services/model.service';
import {CollectionService} from '../../../Services/collection.service';
import {StyleService} from '../../../Services/style.service';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'app-manage-model',
  templateUrl: './manage-model.component.html',
  styleUrls: ['./manage-model.component.scss']
})
export class ManageModelComponent implements OnInit {
  public model: Model = new Model();
  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  public modalId: number;
  public collectionId: number;
  public isEdit = false;
  public collections = [];
  public supliers = [];
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;
  public styles = [];
  public selectedStyles = [];
  private isDone = true;


  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private modelService: ModelService,
    private collectionService: CollectionService,
    private styleService: StyleService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.modelService.getSuppliers().subscribe((resp) => {
      const respItem = resp.data;
      respItem.map((value) => {
        this.supliers.push({
          label: value.companyName,
          value: value.id
        });
      });

      this.collectionId = this.route.snapshot.params['collectionId'];
      this.route.params.subscribe(params => {
        if (Helper.isDefined(params['id'])) {
          this.modalId = params['id'];
          this.isEdit = true;
          this.modelService.getModelItem(this.modalId).subscribe(resp => {
            resp.collection = resp.collection.id;
            resp.supplier = (resp.supplier) ? resp.supplier.id : null;
            if (resp.styles.length > 0) {
              resp.styles.map((value) => {
                this.selectedStyles.push(value.id);
              });
            }
            this.lastValue = {model: resp};

          });
        }
      });
      this.collectionService.getCollection().subscribe((resp) => {
        resp.data.map((value) => {
          this.collections.push({
            label: value.name,
            value: value.id
          });
        });
        this.styleService.getStyle().subscribe((resp) => {
          resp.data.map((value) => {
            this.styles.push({
              label: value.name,
              value: value.id
            });
          });
          this.classicBox = <FormlyFieldConfig>[
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.model.show.model_details') + '</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'model',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'name',
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.name'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'code',
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.code'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.model.show.collection') + '</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'model',
              fieldGroup: [
                {
                  key: 'collection',
                  type: 'ng-select',
                  className: 'col-3 ',
                  defaultValue: this.collections ? +this.collectionId : false,
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.collection'),
                    required: true,
                    options: this.collections
                  },
                },
                {
                  key: 'hasFabric',
                  type: 'checkbox',
                  className: 'col-3 pt-4',
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.has_fabric'),
                    required: false
                  }
                },
                {
                  key: 'nostyle',
                  type: 'checkbox',
                  className: 'col-3 pt-4',
                  defaultValue: (this.selectedStyles.length > 0),
                  templateOptions: {
                    label: this.translate.instant('admin.style.no_style'),
                    required: false
                  }
                },
                {
                  key: 'styles',
                  type: 'ng-select',
                  className: 'col-3',
                  templateOptions: {
                    multiple: true,
                    label: this.translate.instant('doctrine.model.styles'),
                    required: true,
                    options: this.styles
                  },
                  hooks: {
                    onInit: (field) => {
                      field.formControl.setValue(this.selectedStyles);
                    }
                  },
                  hideExpression: '!model.nostyle',
                  expressionProperties: {
                    'templateOptions.disabled': '!model.nostyle',
                    'templateOptions.required': 'model.nostyle',
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.model.show.other') + '</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'model',
              fieldGroup: [
                {
                  key: 'supplier',
                  type: 'ng-select',
                  className: 'col-3 mb-3',
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.supplier'),
                    required: true,
                    options: this.supliers,
                  },
                },
                {
                  key: 'status',
                  type: 'ng-select',
                  className: 'col-3 ',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.status'),
                    required: true,
                    options: [
                      {label: this.translate.instant('global.active'), value: true},
                      {label: this.translate.instant('global.inactive'), value: false},
                    ],
                  },
                },
                {
                  key: 'message',
                  type: 'input',
                  className: 'col-3',
                  templateOptions: {
                    label: this.translate.instant('doctrine.model.message'),
                    required: false,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {
                          limit: field.templateOptions.maxLength
                        })
                    },
                  },
                }
              ],
            },
          ];
        });
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const model = JSON.parse(JSON.stringify(this.lastValue));
      delete model.model.id;
      delete model.model.productCount;
      delete model.model.products;
      delete model.model.optionProducts;
      if (!model.model.nostyle) {
        delete model.model.styles;
      }
      delete model.model.nostyle;

      this.modelService.manageModel(model, this.isEdit, this.modalId).subscribe((resp) => {
        if (this.collectionId) {
          this.router.navigateByUrl('/back-office/collection/' + this.collectionId + '/show');
        } else {
          this.router.navigateByUrl('/back-office/model/overview');
        }

      });
    } else {
      if (this.collectionId) {
        this.router.navigateByUrl('/back-office/collection/' + this.collectionId + '/show');
      } else {
        this.router.navigateByUrl('/back-office/model/overview');
      }
    }
  }
}
